import axios from 'axios'
import { from } from 'rxjs'
import { tap } from 'rxjs/operators'

function fromPromise(promise, isToastApi) {
  return from(promise).pipe(
    tap(response => {
      if (isToastApi && response.data.header.isSuccessful == false) {
        throw response.data.header
      }
    }),
    tap(response => {}, e => console.error(e))
  )
}

export default {
  get(url, config, isToastApi) {
    if (isToastApi == undefined) {
      isToastApi = true
    }
    return fromPromise(axios.get(url, config), isToastApi)
  },
  post(url, body, config, isToastApi) {
    if (isToastApi == undefined) {
      isToastApi = true
    }
    return fromPromise(axios.post(url, body, config), isToastApi)
  },
  put(url, body, config, isToastApi) {
    if (isToastApi == undefined) {
      isToastApi = true
    }
    return fromPromise(axios.put(url, body, config), isToastApi)
  },
  delete(url, config, isToastApi) {
    if (isToastApi == undefined) {
      isToastApi = true
    }
    return fromPromise(axios.delete(url, config), isToastApi)
  }
}
